document.addEventListener('DOMContentLoaded', () => {
	const rotators = document.querySelectorAll('[data-grid-info-rotator]');

	if (!rotators.length) return;

	rotators.forEach((rotator) => {
		const items = Array.from(rotator.querySelectorAll('[data-rotator-item]'));
		if (items.length <= 1) return;

		let currentIndex = 0;
		const interval = Number(rotator.dataset.interval) || 1500;
		let timerId = null;

		const setActiveItem = (nextIndex) => {
			items.forEach((item, index) => {
				const isActive = index === nextIndex;

				item.classList.toggle('is-active', isActive);
				item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
				item.tabIndex = isActive ? 0 : -1;
			});
		};

		const startRotation = () => {
			if (timerId) clearInterval(timerId);

			timerId = setInterval(() => {
				currentIndex = (currentIndex + 1) % items.length;
				setActiveItem(currentIndex);
			}, interval);
		};

		setActiveItem(currentIndex);
		startRotation();

		rotator.addEventListener('mouseenter', () => {
			if (timerId) clearInterval(timerId);
		});

		rotator.addEventListener('mouseleave', () => {
			startRotation();
		});
	});
});